import ConfirmDialog from './ConfirmDialog';
import type { ModalProps } from './type';

const AcModal = (props: ModalProps) => <ConfirmDialog {...props} />;

export default AcModal;
